import { Space, Text } from "@/atoms"
import { ArrowRightOutlined } from "@/icons"
import { Item, List } from "@/pages/DiscoveryPage/components/molecules/List"

import type { BaseImageFix } from "@/domain/issue"
import type { TFunction } from "@/hooks/useTranslation"

import sharedStyles from "../fixes-shared.module.scss"
import styles from "./BaseImageFixes.module.scss"

export const BaseImageFixesList: React.FC<{
  fixes: BaseImageFix[]
  copyable?: boolean
  t: TFunction
}> = ({ fixes, copyable, t }) => {
  return (
    <List
      limit={copyable ? undefined : 2}
      items={fixes}
      classes={{ list: styles.baseFixesList }}
      render={({ fixType, tags, repository, currentUrl }: BaseImageFix, i) => {
        const itemProps = {
          key: `${fixType}-${i}`,
          classes: {
            item: sharedStyles.listItem,
            value: sharedStyles.listItemValue
          }
        }

        if (fixType === "rebuild") {
          return (
            <Item
              {...itemProps}
              wrap
              title={t("general.patchUpdate")}
              value={`${repository}${tags?.[0] ? `:${tags[0]}` : ""}`}
            />
          )
        }

        if (fixType === "replace" || fixType === "remove") {
          return (
            <Item
              {...itemProps}
              wrap
              title={t(`general.${fixType}Update`)}
              value={""}
            />
          )
        }

        const knownFixType =
          fixType === "patch" || fixType === "minor" || fixType === "major"
        const fixTypeText = knownFixType
          ? `${t(`general.${fixType}Update`)}: `
          : ""
        const currentTagText = currentUrl || repository

        // Used for copy fix
        if (copyable) {
          return (
            <Item title={`${fixTypeText}${currentTagText} -> ${tags?.[0]}`} />
          )
        }

        return (
          <Item
            wrap
            {...itemProps}
            title={
              <Space inline size={4}>
                <Space size={4} baseline inline>
                  <Text className={sharedStyles.titleFixType}>
                    {t(`general.${fixType}Update`)}:
                  </Text>
                  <Text className={sharedStyles.titleCurrentValue}>
                    {currentTagText}
                  </Text>
                </Space>
                <ArrowRightOutlined className={sharedStyles.titleArrow} />
              </Space>
            }
            value={tags?.[0] || ""}
          />
        )
      }}
    />
  )
}
